import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { welcomeCopy } from '../data/translations/welcome';
import { LIGHT_PHOTO_FILTER } from '../utils/photoFilters';
export function WelcomeSection() {
  const {
    language
  } = useLanguage();
  const copy = welcomeCopy[language];
  return <section className="surface-b blend-top relative py-24 overflow-hidden" data-id="element-245" data-mp="u46ft8eysgas">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-246" data-mp="f7fayjmiucds">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-247" data-mp="k7bkszhwgy19">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-248" data-mp="k5gwrcbc0psy">
            <h2 className="font-serif text-4xl md:text-5xl text-ink-900 mb-6" data-id="element-249" data-mp="b8q1v38ingzy">
              {copy.heading}
            </h2>

            <div className="space-y-6 text-ink-600 text-lg leading-relaxed" data-id="element-250" data-mp="25lfxbpej8y9g">
              {copy.paragraphs.map((paragraph, index) => <p key={index} data-id="element-251" data-mp="n7h17w9sdj2m" data-mpi={index}>{paragraph}</p>)}

              {/* Closing quote-like statement */}
              <div className="pt-4 border-l-2 border-bronze-400 pl-5" data-id="element-252" data-mp="j76mnv7xhkc5">
                <p className="font-serif italic text-xl md:text-2xl text-ink-900 leading-relaxed" data-id="element-253" data-mp="wxs89roro8dq">
                  {copy.quote}
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-254" data-mp="4axqx3n8xp4h">
            <div className="absolute inset-0 bg-bronze-400/15 rounded-lg transform rotate-3" data-id="element-255" data-mp="99ioswf0zwpr"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cnGmRMENFYULVRQKswe3Gq/20260920-Mark-LR1.jpg" alt={copy.imageAlt} style={{
            filter: LIGHT_PHOTO_FILTER
          }} className="relative rounded-lg shadow-xl w-full h-auto object-cover aspect-[4/3]" data-id="element-256" data-mp="1pn8ug7lsmt1i" />
          </motion.div>
        </div>
      </div>
    </section>;
}